export function validateophone(that) {
    let checkphoneNumber = (rule, value, callback) => {
        if(that.Register_phoneNumber?that.Register_phoneNumber.length>0?true:false:false){
            if (value === "" && that.Register_phoneNumber[0].requireSwitch == '1') {
                let str = that.$t('register.phoneNumber1')
                callback(new Error(str));
            } else if(value.length > that.Register_phoneNumber[0].lengthMax || value.length < that.Register_phoneNumber[0].lengthMin ){
                let str1 = that.$t('register.phoneRules');
                // let str2 = this.$t('register.allRules');
                // let str3 = this.$t('register.Bit');
                // str2+this.Register_phoneNumber[0].lengthMax+str3
                callback(new Error(str1+that.Register_phoneNumber[0].lengthMin));
            }else {
                callback();
            }
        }
        callback();
      };
    return {
        phone: [
			{ required: true, validator:checkphoneNumber, trigger: 'blur' },
			// { pattern: /^[A-Za-z0-9]{6,12}$/, message: that.$t('register.passwordPlace'), trigger: 'blur' }
		],
    }
}
export function validateLogin(that) {
    return {
        username: [
            { required: true, message:that.$t('login.userRules1'), trigger: 'blur' },
            // { pattern: /^[A-Za-z0-9]{6,12}$/, message: that.$t('login.userRules2'), trigger: 'blur' }
        ],
        password: [
            { required: true, message: that.$t('login.passwordRules'), trigger: 'blur' },
        ],
        verificationCode: [
            { required: true, message: that.$t('login.verificationRules'), trigger: 'blur' }
        ],
    }
}
export function validateRegister(that) {
    let checkrepeatPassword = (rule, value, callback) => {
        let reg = /^[A-Za-z0-9]{6,12}$/;
        if (value === "") {
          let str = that.$t('register.epeatPassword1');
          callback(new Error(str));
        } else if (that.user.repeatPassword !== that.user.password) {
          let str = that.$t('register.epeatPassword2');
          callback(new Error(str));
        } else {
          callback();
        }
    };
      let checkphoneNumber = (rule, value, callback) => {
        if(that.Register_phoneNumber?that.Register_phoneNumber.length>0?true:false:false){
            if (value === "" && that.Register_phoneNumber[0].requireSwitch == '1') {
                let str = that.$t('register.phoneNumber1')
                callback(new Error(str));
            } else if(value.length > that.Register_phoneNumber[0].lengthMax || value.length < that.Register_phoneNumber[0].lengthMin ){
                let str1 = that.$t('register.phoneRules');
                // let str2 = this.$t('register.allRules');
                // let str3 = this.$t('register.Bit');
                // str2+this.Register_phoneNumber[0].lengthMax+str3
                callback(new Error(str1+that.Register_phoneNumber[0].lengthMin));
            }else {
                callback();
            }
        }
        callback();
      };
  
      let checkQQ = (rule, value, callback) => {
        if(this.Register_qq?that.Register_qq.length>0?true:false:false){
            if (value === "" && that.Register_qq[0].requireSwitch == '1') {
                let str = that.$t('register.qqRules')
                callback(new Error(str));
            } else if(value.length > that.Register_qq[0].lengthMax || value.length < that.Register_qq[0].lengthMin ){
                let str1 = that.$t('register.qqRules2');
                let str2 = that.$t('register.allRules');
                let str3 = that.$t('register.Bit');
                callback(new Error(str1+ththatis.Register_qq[0].lengthMin+str2+that.Register_qq[0].lengthMax+str3));
            }else {
                callback();
            }
        }
      };
      let checkrealName = (rule, value, callback) => {
        if(that.Register_realName?that.Register_realName.length>0?true:false:false){
            if (value === "" && that.Register_realName[0].requireSwitch == '1') {
            // callback(new Error($t('register.realNameRules')));
            let str = that.$t('register.realNameRules')
            callback(new Error(str));
            } else if(value.length > that.Register_realName[0].lengthMax || value.length < that.Register_realName[0].lengthMin ){
                let str1 = that.$t('register.realNameRules2');
                let str2 = that.$t('register.allRules');
                let str3 = that.$t('register.Bit');
            callback(new Error(str1));
            //callback(new Error(str1+that.Register_realName[0].lengthMin+str3));
            }else {
            callback();
            }
        }
      };
      let checkwechat = (rule, value, callback) => {
        if(that.Register_wechat?that.Register_wechat.length>0?true:false:false){
            if (value === "" && that.Register_wechat[0].requireSwitch == '1') {
            let str = that.$t('register.realwxRules')
            callback(new Error(str));
            } else if(value.length > that.Register_wechat[0].lengthMax || value.length < that.Register_wechat[0].lengthMin ){
                let str1 = that.$t('register.realwxRules2');
                let str2 = that.$t('register.allRules');
                let str3 = that.$t('register.Bit');
            callback(new Error(str1+that.Register_wechat[0].lengthMin+str2+that.Register_wechat[0].lengthMax+str3));
            }else {
            callback();
            }
        }
      };
      let checkemail = (rule, value, callback) => {
        let reg = /^[A-Za-z0-9]+([_\.][A-Za-z0-9]+)*@([A-Za-z0-9\-]+\.)+[A-Za-z]{2,6}$/;
        if(that.Register_email?that.Register_email.length>0?true:false:false){
            if (value === "" && that.Register_email[0].requireSwitch == '1') {
            let str = that.$t('register.emailRulse')
            callback(new Error(str));
            } else if(value.length > that.Register_email[0].lengthMax || value.length < that.Register_email[0].lengthMin ){
                let str1 = that.$t('register.emailRulse2');
                let str2 = that.$t('register.allRules');
                let str3 = that.$t('register.Bit');
            callback(new Error(str1+that.Register_email[0].lengthMin+str2+that.Register_email[0].lengthMax+str3));
            } else if (!reg.test(value)){
            let str = that.$t('register.emailRulse3')
            callback(new Error(str));
            }
            else {
            callback();
            }
        }
      };
      let checkwithdrawPassword = (rule, value, callback) => {
        if(that.Register_withdrawPassword?that.Register_withdrawPassword.length>0?true:false:false){
            if (value === "" && that.Register_withdrawPassword[0].requireSwitch == '1') {
            let str = that.$t('register.withdrawPasswordRules')
            callback(new Error(str));
            } else if(value.length > that.Register_withdrawPassword[0].lengthMax || value.length < that.Register_withdrawPassword[0].lengthMin ){
                let str1 = that.$t('register.withdrawPasswordRules2');
                let str2 = that.$t('register.allRules');
                let str3 = that.$t('register.Bit');
            callback(new Error(str1+that.Register_withdrawPassword[0].lengthMin+str2+that.Register_withdrawPassword[0].lengthMax+str3));
            }else {
            callback();
            }
        }
      };
      let checkfirstName = (rule, value, callback) => {
        if(that.Register_firstName?that.Register_firstName.length>0?true:false:false){
            if (value === "" && that.Register_firstName[0].requireSwitch == '1') {
            let str = that.$t('register.firstNameRules')
            callback(new Error(str));
            } else if(value.length > that.Register_firstName[0].lengthMax || value.length < that.Register_firstName[0].lengthMin ){
                let str1 = that.$t('register.firstNameRules2');
                let str2 = that.$t('register.allRules');
                let str3 = that.$t('register.Bit');
            callback(new Error(str1+that.Register_firstName[0].lengthMin+str2+that.Register_firstName[0].lengthMax+str3));
            }else {
            callback();
            }
        }
      };
      let checkmiddleName = (rule, value, callback) => {
        if(that.Register_middleName?that.Register_middleName.length>0?true:false:false){
            if (value === "" && that.Register_middleName[0].requireSwitch == '1') {
            let str = that.$t('register.middleNameRules')
            callback(new Error(str));
            } else if(value.length > that.Register_middleName[0].lengthMax || value.length < that.Register_middleName[0].lengthMin ){
                let str1 = that.$t('register.middleNameRules2');
                let str2 = that.$t('register.allRules');
                let str3 = that.$t('register.Bit');
            callback(new Error(str1+that.Register_middleName[0].lengthMin+str2+that.Register_middleName[0].lengthMax+str3));
            }else {
            callback();
            }
        }
      };
      let checklastName = (rule, value, callback) => {
        if(that.Register_lastName?that.Register_lastName.length>0?true:false:false){
            if (value === "" && that.Register_lastName[0].requireSwitch == '1') {
            let str = that.$t('register.lastNameRules')
            callback(new Error(str));
            } else if(value.length > that.Register_lastName[0].lengthMax || value.length < that.Register_lastName[0].lengthMin ){
                let str1 = that.$t('register.lastNameRules2');
                let str2 = that.$t('register.allRules');
                let str3 = that.$t('register.Bit');
            callback(new Error(str1+that.Register_lastName[0].lengthMin+str2+that.Register_lastName[0].lengthMax+str3));
            }else {
            callback();
            }
        }
      };
    return {
        agentCode: [
			{ required: true, message:that.$t('login.agentCode'), trigger: 'blur' },
		],
		username: [
			{ required: true, message:that.$t('login.userRules1'), trigger: 'blur' },
			{ pattern: /^[A-Za-z0-9]{6,12}$/, message: that.$t('register.userPlace'), trigger: 'blur' }
		],
		password: [
			{ required: true, message: that.$t('login.passwordRules'), trigger: 'blur' },
			{ pattern: /^[A-Za-z0-9]{6,12}$/, message: that.$t('register.passwordPlace'), trigger: 'blur' }
		],
        repeatPassword: [ 
            { validator:checkrepeatPassword, trigger: "blur", required: true }
		],
		verificationCode: [
			{ required: true, message: that.$t('login.verificationRules'), trigger: 'blur' },
		],
		phone: [
			{ required: true, validator:checkphoneNumber, trigger: 'blur' },
			// { pattern: /^[A-Za-z0-9]{6,12}$/, message: that.$t('register.passwordPlace'), trigger: 'blur' }
		],
		qq: [
			{ validator: checkQQ, trigger: "blur", required: true }
		],
		realName: [
			{ validator: checkrealName, trigger: "blur", required: true }
		],
		wechat: [
			{ validator: checkwechat, trigger: "blur", required: true }
		],
		email: [
			{ validator: checkemail, trigger: "blur", required: true }
		],
		withdrawPassword: [
			{ validator: checkwithdrawPassword, trigger: "blur", required: true }
		],
        firstName: [
			{ validator: checkfirstName, trigger: "blur", required: true }
		],
        middleName: [
			{ validator: checkmiddleName, trigger: "blur", required: true }
		],
        lastName: [
			{ validator: checklastName, trigger: "blur", required: true }
		],
	}
}





// WEBPACK FOOTER //
// ./src/pages/build901/components/utils/validate.js